import { Box, Grid, Stack, Typography } from '@mui/material';
import React, { useContext } from 'react';
import { LanguageContext } from '../../../../../../../../../libs/Context';

const Pending = (props) =>
{
	const { language } = useContext(LanguageContext);
	const { setComponent } = props;

	return (
		<Grid container justifyContent={'center'} alignItems={'center'}>
			<Grid item xs={12} >
				<Stack direction={'column'} spacing={1} alignItems={'center'} justifyContent={'center'}>
					<Box sx={{ height: '70px', width: '70px' }}
						component='img'
						src='/images/icons/pendingregistration.svg'
					/>
					<Stack direction={'column'} spacing={1} justifyContent={'center'} alignItems={'center'}>
						<Typography variant='body1' fontWeight='var(--font500)' fontSize={'var(--pixel18)'}>{language?.thankYou}</Typography>
						<Typography variant='body1' onClick={() => setComponent(2)} fontWeight='var(--font500)' fontSize={'var(--pixel24)'}>{language?.reqstSub}</Typography>
						<Typography variant='body1' fontSize={'var(--pixel14)'} color={'rgba(126, 146, 162, 1)'} textAlign={'center'}>{language?.webinarDetailsMail}</Typography>
					</Stack>
				</Stack>
			</Grid>
		</Grid>
	);
};

export default Pending;
